import { Button } from 'antd';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import {
  Wrapper,
  InfoWrapper,
  BannerTitle,
  BannerDescription,
  ButtonsWrapper,
  BannerImage
} from './InfoTestTeacherBanner.styles';

import INFO_TEST_BANNER_IMG from '@/assets/info-test-banner.png';

export const InfoTestTeacherBanner: React.FC = () => {
  const { t } = useTranslation('InfoTestTeacherBannerTranslations');
  const navigateTo = useNavigate();
  const handlePractice = () => {
    navigateTo('/content/tests');
  };

  const handleLearnMore = () => {
    window.open(
      'https://ucademy.atlassian.net/wiki/external/Zjc0ZjAwNDgyNWI4NDVjNmIyYjY0YzA4YTBjMjFjZGY',
      '_blank'
    );
  };

  return (
    <Wrapper>
      <InfoWrapper>
        <BannerTitle>{t('NEW_TEST_MODES')}</BannerTitle>
        <BannerDescription>{t('DISCOVER_NEW_TEST_MODES')}</BannerDescription>
        <ButtonsWrapper>
          <Button type="primary" onClick={handlePractice}>
            {t('CREATE_TEST')}
          </Button>
          <Button onClick={handleLearnMore}>{t('LEARN_MORE')}</Button>
        </ButtonsWrapper>
      </InfoWrapper>
      <BannerImage src={INFO_TEST_BANNER_IMG} alt="Quiz Banner" />
    </Wrapper>
  );
};
